module.exports = __webpack_public_path__ + "static/img/ent-detail-65.6948f35.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/entpic/ent-detail-65.jpg
// module id = BjP+
// module chunks = 51